import { useEffect } from 'react';

import ProtectionServiceEnum from 'redpoints-model-js-common/enumeration/ProtectionServiceEnum';

import { withContext } from 'redpoints-front-common-rp10/components';
import type { WithContextProps } from 'redpoints-front-common-rp10/components/LayoutMainContext/HOCs/withContext';
import { hasProtectionService } from 'redpoints-front-common-rp10/helpers';
import { useConfiguration } from 'redpoints-front-common-rp10/hooks';

type DomainManagementProps = Pick<
  WithContextProps,
  'getProtectionServicesOfCurrentContract'
>;

type PortalDomainManagement = NonNullable<
  ReturnType<typeof useConfiguration>['portalDomainManagement']
>;

const DomainManagement = ({
  getProtectionServicesOfCurrentContract,
}: DomainManagementProps): null => {
  const { portalDomainManagement } = useConfiguration();

  useEffect(() => {
    if (portalDomainManagement) {
      const contractProtectionServices = getProtectionServicesOfCurrentContract();
      const url = getUrl(contractProtectionServices, portalDomainManagement);
      window.open(url, '_blank');
      window.history.back();
    }
  }, [portalDomainManagement, getProtectionServicesOfCurrentContract]);

  return null;
};

const getUrl = (
  contractProtectionServices: ReturnType<
    WithContextProps['getProtectionServicesOfCurrentContract']
  >,
  { urls: { enabled, disabled } }: PortalDomainManagement
): string =>
  hasProtectionService(
    ProtectionServiceEnum.DOMAINMANAGEMENT,
    contractProtectionServices
  )
    ? enabled
    : disabled;

export default withContext(DomainManagement);
